import { HttpPostFunction } from "@lookiero/sty-psp-http";
import {
  ViewStyleProfileDefinitionByCustomerIdResult,
  StyleProfileDefinitionByCustomerIdView,
} from "../../../projection/styleProfileDefinition/viewStyleProfileDefinitionByCustomerId";

interface HttpStyleProfileDefinitionByCustomerIdView extends StyleProfileDefinitionByCustomerIdView {}

interface HttpStyleProfileDefinitionByCustomerIdViewFunctionArgs {
  readonly httpPost: HttpPostFunction;
}

interface HttpStyleProfileDefinitionByCustomerIdViewFunction {
  (args: HttpStyleProfileDefinitionByCustomerIdViewFunctionArgs): HttpStyleProfileDefinitionByCustomerIdView;
}

const httpStyleProfileDefinitionByCustomerIdView: HttpStyleProfileDefinitionByCustomerIdViewFunction =
  ({ httpPost }) =>
  async ({ customerId, signal }) =>
    await httpPost<ViewStyleProfileDefinitionByCustomerIdResult>({
      endpoint: "/view-style-profile-definition-by-customer-id",
      body: { customerId },
      signal,
      result: {
        error: null,
        success: (response) => response,
      },
    });

export { httpStyleProfileDefinitionByCustomerIdView };
